






































































































































































































/** @format */

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BdSwitch from '@/components/bd-switch';
import { cloneDeep } from 'lodash';
import { IByTimeMainForm, byTimeMainFormDefault, IByTimeBackUpForm, byTimeBackUpFormDefault } from './type';

@Component({
  components: { BdSwitch }
})
export default class ByTimeRule extends Vue {
  @Prop({
    type: String,
    default: ''
  })
  datePattern!: string;

  @Prop()
  byTimeMainForm!: IByTimeMainForm;
  //  = byTimeMainFormDefault
  @Prop()
  byTimeBackUpForm!: IByTimeBackUpForm;
  // = byTimeBackUpFormDefault
  @Prop({
    type: Boolean,
    default: true
  })
  disabled!: boolean;
  mounted() {}

  // 按时计费111
  addbyTimeMain() {
    try {
      if (
        this.byTimeMainForm &&
        this.byTimeMainForm.limitMoneyOfDefines.length > 0 &&
        this.byTimeMainForm.limitMoneyOfDefines[this.byTimeMainForm.limitMoneyOfDefines.length - 1].limitTime !== 0 &&
        this.byTimeMainForm.limitMoneyOfDefines[this.byTimeMainForm.limitMoneyOfDefines.length - 1].money !== 0
      ) {
        this.byTimeMainForm.limitMoneyOfDefines.push({ limitTime: 0, money: 0 });
      } else {
        return this.$message.warning('请填写完整');
      }
    } catch (e) {
      console.log(e);
    }
  }
  delbyTimeMain(index: number) {
    try {
      if (this.byTimeMainForm && this.byTimeMainForm.limitMoneyOfDefines.length > 1) {
        this.byTimeMainForm.limitMoneyOfDefines.splice(index, 1);
      }
    } catch (e) {
      console.log(e);
    }
  }
}
